module.exports = __webpack_public_path__ + "img/ticketing-system-2-mobile.c9466430.png";